<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.$store.dispatch('getCompany').then(() => {
      let ujetScript = document.createElement('script');
      ujetScript.setAttribute('src', this.$store.getters.webSDK);
      document.head.appendChild(ujetScript)
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
body{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue